<template>
    <div>
        <el-dialog :visible.sync="dialog" width="1080px" :close-on-click-modal="false" top="50px">
            <div>
                <!-- 基本信息 -->
                <info-basic :info-data='info' />

                <!-- 账号视频作品分析 -->
                <info-work-analysis :info-data='info' />
            </div>
            <div slot="footer" class="dialog-footer text-center">
                <el-button @click="dialog = false">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import InfoBasic from '../_components/InfoBasic'
import InfoWorkAnalysis from '../_components/InfoWorkAnalysis'

export default {
    props: {
        value: {
            type: Boolean,
            default: true,
        },
        infoData: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    components: {
        InfoBasic,
        InfoWorkAnalysis,
    },
    data() {
        return {
            dialog: !!this.value,
        }
    },
    computed: {
        info() {
            return this.infoData
        }
    },
    methods: {

    },
    async mounted() {
        // await this.getCaptcha()
    },
    watch: {
        dialog(val) {
            if (!val) this.$emit('input', val)
        },
    },
}
</script>

<style lang="scss" scoped>
.top-tip {
    margin-top: -20px;
    margin-bottom: 20px;
}
.captcha-img {
    position: absolute;
    height: 38px;
    right: 1px;
    top: 1px;
}
</style>
